import { useRef } from "react";

/**
 * 外部 anchor の button（フィルタートリガー）を開閉トグルにする。
 *
 * Popover の outside-press は anchor 上のクリックでも発火して閉じるため、続く onClick が
 * そのまま再オープンしてしまう（しかも dismiss は pointerdown で先に閉じて再レンダーするので、
 * onClick の closure 内 open は false になり「開いていたか」で分岐できない）。
 * そこで pointerdown 時点の open を ref に退避し、開いていたクリックでは onOpen せず onClose する。
 *
 * 使い方: onPointerDown を anchor 要素に、onClick を button に渡す。
 */
export function useTriggerToggle(
  open: boolean,
  onOpen: () => void,
  onClose: () => void,
) {
  const wasOpenRef = useRef(false);
  return {
    onPointerDown: () => {
      wasOpenRef.current = open;
    },
    onClick: () => {
      if (wasOpenRef.current) {
        onClose();
        return;
      }
      onOpen();
    },
  };
}
